export default [
  "•••• •••• •••• ••••",
  "···· ···· ···· ····",
  "•••••••••",
  "·········",
  "••••",
  "····",
  "•••",
  "···",
];
